<div class="dialog-wrapper" dir="rtl">
  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">إضافة تعليق</h2>
    <button class="close-btn" (click)="onClose()">
      <span>&#x2715;</span>
    </button>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <!-- الفرع -->
    <div class="form-group">
      <label class="form-label">الفرع</label>
      <div class="select-wrapper">
        <select class="form-select" [(ngModel)]="selectedBranch" name="branch">
          <option value="TestBranch">TestBranch</option>
          <option value="Branch1">Branch 1</option>
          <option value="Branch2">Branch 2</option>
        </select>
        <span class="select-arrow">&#x2039;</span>
      </div>
    </div>

    <!-- أهمية التعليق -->
    <div class="form-group">
      <label class="form-label">أهمية التعليق</label>
      <div class="select-wrapper">
        <select
          class="form-select"
          [(ngModel)]="selectedImportance"
          name="importance"
        >
          <option value="low">أهمية منخفضة</option>
          <option value="medium">أهمية متوسطة</option>
          <option value="high">أهمية عالية</option>
        </select>
        <span class="select-arrow">&#x2039;</span>
      </div>
    </div>

    <!-- تعليق -->
    <div class="form-group">
      <label class="form-label">تعليق</label>
      <textarea
        class="form-textarea"
        [(ngModel)]="comment"
        name="comment"
        rows="4"
        placeholder=""
      ></textarea>
    </div>
  </div>

  <!-- Footer Buttons -->
  <div class="dialog-footer">
    <button class="btn btn-cancel" (click)="onClose()">إلغاء</button>
    <button class="btn btn-submit" (click)="onSubmit()">تسجيل</button>
  </div>
</div>
